module.exports = __webpack_public_path__ + "static/media/Sharp-Technology-IGZO-High-Resolution-2.bcba30de.png";